/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { LoaderCircle } from 'lucide-react';
import { useI18n } from '@/context/I18nContext';

interface AppLoaderProps {
    label?: string;
    spinnerSize?: 'default' | 'kpi';
}

function AppLoader({ label, spinnerSize = 'default' }: AppLoaderProps) {
    const { t } = useI18n();
    const resolvedLabel = label ?? t('Loading...');

    return (
        <div
            className="flex h-full min-h-0 w-full flex-col items-center justify-center gap-3 p-6 text-base-content/60"
            role="status"
            aria-live="polite"
        >
            <LoaderCircle
                className={`${spinnerSize === 'kpi' ? 'h-4 w-4' : 'h-7 w-7'} animate-spin`}
                aria-hidden="true"
            />
            <span className="text-center text-sm font-medium leading-relaxed">{resolvedLabel}</span>
        </div>
    );
}

export default AppLoader;
